import { render, staticRenderFns } from "./InstalltaskDetail.vue?vue&type=template&id=deae5f96&scoped=true&"
import script from "./InstalltaskDetail.vue?vue&type=script&lang=js&"
export * from "./InstalltaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./InstalltaskDetail.vue?vue&type=style&index=0&id=deae5f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deae5f96",
  null
  
)

export default component.exports